<template>
	<div class="main" ref="containe">
		<swiper class="swiperBox" :options="swiperOptions" ref="mySwiper" v-if="screenWidth>750">
			<swiper-slide>
				<div class="container">
					<div class="heroSection" @click="showLoginBox = false" :style="{height: adboxHeight + 'px',backgroundImage: `url(${adbg})`}">
						<headNav @click.stop="" @navClick="navClick"
						@openLoginBox="openLoginBox"></headNav>
						<!-- <div style="height: 96px;"></div> -->
						<div class="heroContent">
							<div class="flex_start">
								<div class="heroTagline flex_start">
									<span>强大技术，助力您的广告收益持续增长</span>
									<img class="heroTaglineIcon" src="../assets/index/adicon.png" alt="" />
								</div>
							</div>
							<div class="heroHeading">专业技术助您轻松实现高效<br /><span>广告变现</span></div>
							<div class="heroDescription">提供媒体高质量广告变现，助您实现收益最大化</div>
							<div class="experienceBtn" @click.stop="openLoginBox">立即体验</div>
						</div>
						<div class="heroFeaturesWrap">
							<div class="heroFeatures flex_center">
								<div class="heroFeature">
									<div class="heroFeatureHeading flex_start">
										<img class="heroFeatureIcon" src="../assets/index/adimg1.png" alt="">
										<div class="heroFeatureTitle">收益提升</div>
									</div>
									<div class="heroFeatureBody">
										<!-- <div class="heroFeatureTitle">收益提升</div> -->
										<div class="heroFeatureText">实时竞价，助力媒体取得更高收益</div>
									</div>
								</div>
								<div class="heroFeature">
									<div class="heroFeatureHeading flex_start">
										<img class="heroFeatureIcon" src="../assets/index/adimg2.png" alt="">
										<div class="heroFeatureTitle">技术优势</div>
									</div>
									<div class="heroFeatureBody">
										<div class="heroFeatureText">多平台竞价，成熟轻量化SDK，接入便捷</div>
									</div>
								</div>
								<div class="heroFeature">
									<div class="heroFeatureHeading flex_start">
										<img class="heroFeatureIcon" src="../assets/index/adimg3.png" alt="">
										<div class="heroFeatureTitle">服务完善</div>
									</div>
									<div class="heroFeatureBody">
										<div class="heroFeatureText">专业技术团队，快速应答问题反馈</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
			<swiper-slide>
				<div class="container" :style="{backgroundImage: `url(${productServiceBg})`}">
					<div class="productBox">
						<div class="productTitle">产品<span>服务</span></div>
						<div class="productTips">专业技术、优化效果</div>
						<div class="productList space_between">
							<div class="productBoxOne">
								<div class="proTitle"><span>专业</span>的技术服务</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									提供高质量、可靠、灵活的技术支持和服务，以帮助广告主和开发者更好地管理和优化广告投放和快速解决技术问题和疑问，以确保广告投放和应用开发的顺利进行。
								</div>
							</div>
							<div class="productBoxOne2">
								<div class="proTitle"><span>多样化</span>的广告</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									我们拥有丰富的广告资源和与多家知名广告平台的合作关系，可以为开发者提供更多元、更高端的广告资源和更高的广告出价，实现广告填充率的提高和收益的优化；多样化广告形式，更大的广告变现空间
								</div>
				
							</div>
							<div class="productBoxOne3">
								<div class="proTitle"><span>优化</span>投放效果和效率</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									优化广告效果，增加广告收入，针对不同的应用场景和用户需求，自动优选最优广告，最大化广告收益。同时，提供多种广告形式和样式，满足广告主的不同需求，提高广告投放效果和转化率。
								</div>
							</div>
						</div>
						<div class="proBottomBox">全行业优质广告资源，帮助各类APP获得商业成长</div>
					</div>
				</div>
			</swiper-slide>
			<swiper-slide>
				<div class="container" style="padding-top: 104px;" :style="{backgroundImage: `url(${adsBg})`}">
					<div class="productBox flex_center">
						<div>
							<div class="productTitle2">
								<div><span>多种</span>广告形式</div>
								<img src="../assets/index/productTxtBg2.png" alt="" />
							</div>
							<div class="productTips" style="text-align: left;">丰富多样的广告形式，精准定向</div>
							<div class="adTabNavList flex_start">
								<div class="adTabNavBox" v-for="(item,index) in adNavList" :key="index" @click="adNavChange(item,index)" 
								:class="{adNavActive:adNavIndex==index}">{{item.name}}</div>
							</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe1}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe2}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe3}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe4}}</div>
						</div>
						<div class="adRightShow flex_center">
							<img :src="adCheckedForm.adModelImg" alt="" />
						</div>
					</div>
				</div>
			</swiper-slide>
			<swiper-slide>
				<!-- style="background-color: #F1F7FF;" -->
				<div class="container" :style="{backgroundImage: `url(${cooperateBg})`}">
					<div class="productBox" style="padding-top: 1%;">
						<div class="productTitle3">变现<span>合作</span>伙伴</div>
						<div class="productTips">服务众多媒体，助力媒体实现收益提升及增长目标</div>
						<div class="cooperateRow">
							<img class="cooperateImg" src="../assets/index/cooperateimg.png" alt="" />
							<div class="cooperateBox">
								<div class="contactusTit">联系我们，助力您获得收益</div>
								<!-- <div class="contactusTit"></div> -->
								<!-- <div class="contactusTxt">为你提供优质的服务</div> -->
								<div class="contactQQ flex_center">
									<img class="qqImg" src="../assets/index/wechatimg.png" alt="" />
									<div class="qqTxt">332120174</div>
								</div>
								<div class="contactLabels flex_start">
									<!-- <div class="iconLabel"></div> -->
									<div class="contactLabelTxt">● 广告投放合作</div>
									<div class="contactLabelTxt">● 广告投放合作</div>
								</div>
							</div>
						</div>
						<div class="cooperateBottomRow flex_center">
							<!-- <img class="bottomLogo" src="../assets/index/logo.png" alt="" /> -->
							<div class="icpTxt">杭州互裕科技有限公司 <a href="https://beian.miit.gov.cn">浙ICP备2020045215号-3</a></div>
						</div>
					</div>
				</div>
			</swiper-slide>
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
		<!-- h5端 -->
		<div v-else>
			<headNav :screenWidth="screenWidth" @click.stop="" @navClick="navClick" @showVisible="showVisible" :showLoginBox="showLoginBox"></headNav>
			<div @click="showLoginBox = false">
				<div class="heroTagline flex_center">
						<span>强大技术，助力您的广告收益持续增长</span>
						<img class="heroTaglineIcon" src="../assets/index/adicon.png" alt="" />
					</div>
					<div class="heroSection" :style="{height: adboxHeight_m + 'px',backgroundImage: `url(${adbg_m})`}">
						<div class="heroHeading">专业技术助您轻松实现高效<br /><span>广告变现</span></div>
						<div class="heroDescription">提供媒体高质量广告变现，助您实现收益最大化</div>
						<div class="flex_center"><div class="experienceBtn">立即体验</div></div>
					</div>
					<div class="heroFeatures">
						<div class="heroFeature">
							<div class="heroFeatureHeading flex_start">
								<img class="heroFeatureIcon" src="../assets/index/adimg1.png" alt="">
								<div class="heroFeatureTitle">收益提升</div>
							</div>
							<div class="heroFeatureBody">
								<!-- <div class="heroFeatureTitle">收益提升</div> -->
								<div class="heroFeatureText">实时竞价，助力媒体取得更高收益</div>
							</div>
						</div>
						<div class="heroFeature">
							<div class="heroFeatureHeading flex_start">
								<img class="heroFeatureIcon" src="../assets/index/adimg2.png" alt="">
								<div class="heroFeatureTitle">技术优势</div>
							</div>
							<div class="heroFeatureBody">
								<div class="heroFeatureText">多平台竞价，成熟轻量化SDK，接入便捷</div>
							</div>
						</div>
						<div class="heroFeature" style="border: none;">
							<div class="heroFeatureHeading flex_start">
								<img class="heroFeatureIcon" src="../assets/index/adimg3.png" alt="">
								<div class="heroFeatureTitle">服务完善</div>
							</div>
							<div class="heroFeatureBody">
								<div class="heroFeatureText">专业技术团队，快速应答问题反馈</div>
							</div>
						</div>
					</div>
					<div class="productBox">
						<div class="productTitle">产品<span>服务</span></div>
						<div class="productTips">专业技术、优化效果</div>
						<div class="productList">
							<div class="productBoxOne">
								<div class="proTitle"><span>专业</span>的技术服务</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									提供高质量、可靠、灵活的技术支持和服务，以帮助广告主和开发者更好地管理和优化广告投放和快速解决技术问题和疑问，以确保广告投放和应用开发的顺利进行。
								</div>
							</div>
							<div class="productBoxOne2">
								<div class="proTitle"><span>多样化</span>的广告</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									我们拥有丰富的广告资源和与多家知名广告平台的合作关系，可以为开发者提供更多元、更高端的广告资源和更高的广告出价，实现广告填充率的提高和收益的优化；多样化广告形式，更大的广告变现空间
								</div>
									
							</div>
							<div class="productBoxOne3">
								<div class="proTitle"><span>优化</span>投放效果和效率</div>
								<div class="proSplitLine"></div>
								<div class="proCont">
									优化广告效果，增加广告收入，针对不同的应用场景和用户需求，自动优选最优广告，最大化广告收益。同时，提供多种广告形式和样式，满足广告主的不同需求，提高广告投放效果和转化率。
								</div>
							</div>
						</div>
						<div class="proBottomBox">全行业优质广告资源，帮助各类APP获得商业成长</div>
					</div>
					<div class="productBox">
						<div>
							<div class="productTitle2_m">
								<span>多种</span>广告形式
							</div>
							<div class="productTips">丰富多样的广告形式，精准定向</div>
							<div class="adTabNavList space_between">
								<div class="adTabNavBox" v-for="(item,index) in adNavList" :key="index" @click="adNavChange(item,index)" 
								:class="{adNavActive:adNavIndex==index}">{{item.name}}</div>
							</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe1}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe2}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe3}}</div>
							<div class="adMannerDescribe">{{adCheckedForm.describe4}}</div>
						</div>
						<div class="adRightShow flex_center">
							<img :src="adCheckedForm.adModelImg" alt="" />
						</div>
					</div>
					<div class="productBox proBoxBg" style="padding-top: 1%;">
						<div class="productTitle3">变现<span>合作</span>伙伴</div>
						<div class="productTips">服务众多媒体，助力媒体实现收益提升及增长目标</div>
						<div class="cooperateRow">
							<img class="cooperateImg" src="../assets/index/cooperateimg_m.png" alt="" />
							<div class="cooperateBox">
								<div class="contactusTit">联系我们，助力您获得收益</div>
								<!-- <div class="contactusTit"></div> -->
								<!-- <div class="contactusTxt">为你提供优质的服务</div> -->
								<div class="contactQQ flex_center">
									<img class="qqImg" src="../assets/index/wechatimg.png" alt="" />
									<div class="qqTxt">332120174</div>
								</div>
								<div class="contactLabels flex_start">
									<!-- <div class="iconLabel"></div> -->
									<div class="contactLabelTxt">● 广告投放合作</div>
									<div class="contactLabelTxt">● 广告投放合作</div>
								</div>
							</div>
						</div>
						<div class="cooperateBottomRow flex_center">
							<!-- <img class="bottomLogo" src="../assets/index/logo.png" alt="" /> -->
							<div class="icpTxt">杭州互裕科技有限公司 <a href="https://beian.miit.gov.cn">浙ICP备2020045215号-3</a></div>
						</div>
					</div>
				</div>
			</div>
		<!-- <footerNav></footerNav> -->
		<el-dialog title="欢迎登录" :visible.sync="loginDialogVisible" width="24%" :modal-append-to-body="false"
			:close-on-click-modal="false">
			<el-form inline class="el-form-dialog" :rules="rulesApi" :model="loginFormData" ref="ruleFormLogin">
				<el-form-item label="" prop="userName">
					<el-input clearable v-model="loginFormData.userName" size="small" placeholder="请输入邮箱地址或账号"></el-input>
				</el-form-item>
				<el-form-item label="" prop="password">
					<el-input :type="!passwordRegisterVisible?'password':'text'" v-model="loginFormData.password" size="small"
						placeholder="请输入密码" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
						<template slot="append">
							<img src="../assets/icon/eyeOpenIcon.png" alt="" class="eyesImg" v-show="!passwordRegisterVisible" @click="passwordRegisterVisible=true" />
							<img src="../assets/icon/eyeCloseIcon.png" alt="" class="eyesImg" v-show="passwordRegisterVisible" @click="passwordRegisterVisible=false" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item>
					<div class="privacyPolicy">
						<el-checkbox v-model="privacyPolicy">我已阅读并同意 <span @click.stop="privacy(1)">服务协议</span> 和 <span
								@click.stop="privacy(2)">隐私条款</span></el-checkbox>
					</div>
				</el-form-item>
				<div class="card-bottom flex_center">
					<el-button class="loginBtns" type="primary" @click="confirmLogin('ruleFormLogin')"
						size="medium">登录</el-button>
				</div>
				<div class="bottomTips space_between">
					<div @click="showRegisterBox">注册</div>
					<div @click="showForgetBox">忘记密码</div>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="账号注册" :visible.sync="registerDialogVisible" width="24%" :modal-append-to-body="false"
			:close-on-click-modal="false">
			<el-form inline class="el-form-dialog" :rules="rulesApiRegister" :model="registerFormData" ref="ruleFormRegister">
				<el-form-item label="" prop="email">
					<el-input clearable v-model="registerFormData.email" size="small" placeholder="请输入邮箱地址"></el-input>
				</el-form-item>
				<!-- 验证码 -->
				<el-form-item label="" prop="code">
					<el-input v-model="registerFormData.code" size="small" placeholder="请输入验证码">
						<template slot="append">
							<el-button v-if="codeShow" type="primary" @click="sendCode(1)">发送验证码</el-button>
							<span v-if="!codeShow" class="count">{{countCode}}秒后重试</span>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="password">
					<el-input :type="!passwordRegisterVisible?'password':'text'" v-model="registerFormData.password" size="small"
						placeholder="请输入密码" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
						<template slot="append">
							<img src="../assets/icon/eyeOpenIcon.png" alt="" class="eyesImg" v-show="!passwordRegisterVisible" @click="passwordRegisterVisible=true" />
							<img src="../assets/icon/eyeCloseIcon.png" alt="" class="eyesImg" v-show="passwordRegisterVisible" @click="passwordRegisterVisible=false" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="againPassword">
					<el-input :type="!passwordRegisterVisible?'password':'text'" v-model="registerFormData.againPassword" size="small"
						placeholder="请再次输入密码" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
						<template slot="append">
							<img src="../assets/icon/eyeOpenIcon.png" alt="" class="eyesImg" v-show="!passwordRegisterVisible" @click="passwordRegisterVisible=true" />
							<img src="../assets/icon/eyeCloseIcon.png" alt="" class="eyesImg" v-show="passwordRegisterVisible" @click="passwordRegisterVisible=false" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="phone">
					<el-input clearable v-model="registerFormData.phone" size="small" placeholder="请输入联系人手机号"></el-input>
				</el-form-item>
				<el-form-item label="" prop="companyName">
					<el-input clearable v-model="registerFormData.companyName" size="small" placeholder="请输入公司名称"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="privacyPolicy">
						<el-checkbox v-model="privacyPolicy">我已阅读并同意 <span @click.stop="privacy(1)">服务协议</span> 和 <span
								@click.stop="privacy(2)">隐私条款</span></el-checkbox>
					</div>
				</el-form-item>
				<div class="card-bottom flex_center">
					<el-button class="loginBtns" type="primary" @click="confirmRegister('ruleFormRegister')"
						size="medium">注册</el-button>
				</div>
				<div class="bottomTips space_between">
					<div @click="openLoginBox">已有账号，去登录</div>
					<!-- <div>忘记密码</div> -->
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="忘记密码" :visible.sync="forgetPwdDialogVisible" width="24%" :modal-append-to-body="false"
			:close-on-click-modal="false">
			<el-form inline class="el-form-dialog" :rules="rulesApiForgetPwd" :model="forgetPwdFormData"
				ref="ruleFormForgetPwd">
				<el-form-item label="" prop="email">
					<el-input clearable v-model="forgetPwdFormData.email" size="small" placeholder="请输入邮箱地址"></el-input>
				</el-form-item>
				<el-form-item label="" prop="code">
					<el-input clearable v-model="forgetPwdFormData.code" size="small" placeholder="请输入验证码">
						<template slot="append">
							<el-button v-if="codeShow" type="primary" @click="sendCode(2)">发送验证码</el-button>
							<span v-if="!codeShow" class="count">{{countCode}}秒后重试</span>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="password">
					<el-input :type="!passwordRegisterVisible?'password':'text'" v-model="forgetPwdFormData.password" size="small"
						placeholder="请输入密码" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
						<template slot="append">
							<img src="../assets/icon/eyeOpenIcon.png" alt="" class="eyesImg" v-show="!passwordRegisterVisible" @click="passwordRegisterVisible=true" />
							<img src="../assets/icon/eyeCloseIcon.png" alt="" class="eyesImg" v-show="passwordRegisterVisible" @click="passwordRegisterVisible=false" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="" prop="againPassword">
					<el-input :type="!passwordRegisterVisible?'password':'text'" v-model="forgetPwdFormData.againPassword" size="small"
						placeholder="请再次输入密码" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
						<template slot="append">
							<img src="../assets/icon/eyeOpenIcon.png" alt="" class="eyesImg" v-show="!passwordRegisterVisible" @click="passwordRegisterVisible=true" />
							<img src="../assets/icon/eyeCloseIcon.png" alt="" class="eyesImg" v-show="passwordRegisterVisible" @click="passwordRegisterVisible=false" />
						</template>
					</el-input>
				</el-form-item>
				<div class="card-bottom flex_center">
					<el-button class="loginBtns" type="primary" @click="confirmForgetPwd('ruleFormForgetPwd')"
						size="medium">确认</el-button>
				</div>
				<div class="bottomTips space_between">
					<div @click="openLoginBox">登录</div>
					<div @click="showRegisterBox">注册</div>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper'
	import 'swiper/dist/css/swiper.css'
	import footerNav from "../components/footer.vue";
	import headNav from "../components/headNav.vue";
	export default {
		components: {
			footerNav,
			headNav,
			swiper,
			swiperSlide,
		},
		data() {
			const checkMobile = (rule, value, callback) => {
				const regCN = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
				if (!regCN.test(value)) {
					callback(new Error('手机号格式不正确'))
				} else {
					callback()
				}
			}
			const checkMail = (rule, value, callback) => {
				const regCN = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
				if (!regCN.test(value)) {
					callback(new Error('邮箱格式不正确'))
				} else {
					callback()
				}
			}
			const checkPassword = (rule, value, callback) => {
			  if (value.length < 6 || value.length > 20) {
			    return callback(new Error('密码长度必须在6到20位之间'));
			  }
			  if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
			    return callback(new Error('密码必须同时包含英文和数字'));
			  }
				const forbiddenChars = ['\\', ' ', '*'];
				for (let char of forbiddenChars) {
				  if (value.includes(char)) {
				    return callback(new Error(`密码不能包含字符“${char}”`));
				  }
				}
			  callback();
			};
			return {
				swiperOptions: {
					direction: 'vertical', // 垂直切换选项
					// loop: true, // 循环模式选项
					mousewheel: true,
					// 如果需要分页器
					pagination: {
						el: '.swiper-pagination',
						clickable: true, //设置小原店面可以切换
					},
				},
				adIndex: 1,
				screenHeight: 0,
				adboxHeight: 0,
				adboxHeight_m: 0,
				adbox2Height: 0,
				showLoginBox: false,
				adbg: this.BASE_URL + 'officialimg/adbg.png',
				adbg_m: require('../assets/index/adbg_m.png'),
				adsBg: this.BASE_URL + 'officialimg/adsBg.png',
				cooperateBg: this.BASE_URL + 'officialimg/cooperateBg.png',
				productServiceBg: this.BASE_URL + 'officialimg/productServiceBg.png',
				adNavList: [
					{
						name: '开屏',
						describe1: '启动页广告，出现在APP启动加载时',
						describe2: '将广告图片或视频展示固定时间，展示完毕后自动关闭并进入APP主页面',
						describe3: '抢占应用开启的“黄金5秒”，用户关注度较高',
						describe4: '推荐场景：所有应用的启动页',
						adModelImg: require('../assets/index/adModel1.png')
					},
					{
						name: '插屏',
						describe1: '触发式广告，在用户做出相应的操作（如开启、暂停、过关、跳转、退出）后',
						describe2: '弹出的以图片、视频等为表现形式的半屏或全屏广告',
						describe3: '曝光度高，视觉冲击力强',
						describe4: '推荐场景：视频贴片、弹窗场景',
						adModelImg: require('../assets/index/adModel2.png')
					},
					{
						name: '全屏视频',
						describe1: '通过应用内奖励吸引用户主动选择观看的全屏视频形式广告',
						describe2: '用户获得应用内奖励的同时，开发者获得丰厚变现收益',
						describe3: '推荐场景：应用的内容流中穿插展示，默认全屏展示',
						describe4: '',
						adModelImg: require('../assets/index/adModel3.png')
					},
					{
						name: 'BANNER',
						describe1: 'banner广告又叫横幅广告、通栏广告、广告条',
						describe2: '嵌入在APP页面中相对固定位置的版面',
						describe3: '是最早采用、最常见的一种广告形式',
						describe4: '推荐场景：视频播放页、工具功能页等顶部、中部、底部',
						adModelImg: require('../assets/index/adModel4.png')
					},
					{
						name: '信息流',
						describe1: '以图文或视频等形式展现在APP的内容流中',
						describe2: '与APP的日常内容（如资讯流、动态流）融为一体',
						describe3: '以原生广告形式对用户干扰小，用户体验友好',
						describe4: '推荐场景：资讯页、视频详情页、信息列表页',
						adModelImg: require('../assets/index/adModel5.png')
					},
					{
						name: '激励视频',
						describe1: '在APP内场景设置选项，激励用户去观看视频广告，从而获得特定权益',
						describe2: '为获取奖励需观看的视频广告，沉浸式视频可深刻触达用户',
						describe3: '沉浸式的广告体验，用户可免费获得更多奖励，广告点击率、转化率极具优势',
						describe4: '推荐场景：获取应用内奖励及权益体系的所有应用及场景',
						adModelImg: require('../assets/index/adModel6.png')
					},
				],
				adNavIndex: 0,
				adCheckedForm: {
					describe1: '启动页广告，出现在APP启动加载时',
					describe2: '将广告图片或视频展示固定时间，展示完毕后自动关闭并进入APP主页面',
					describe3: '抢占应用开启的“黄金5秒”，用户关注度较高',
					describe4: '推荐场景：所有应用的启动页',
					adModelImg: require('../assets/index/adModel1.png')
				},
				screenWidth: 1920,
				
				
				
				formData: {},
				loginFormData: {},
				registerFormData: {},
				forgetPwdFormData: {},
				passwordRegisterVisible: false,
				rulesApi: {
					userName: [{
						required: true,
						message: '请输入邮箱地址或账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					// captcha: [{required: true,message: '请输入验证码',trigger: 'blur'}],
				},
				rulesApiRegister: {
					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							validator: checkMail,
							trigger: 'change'
						},
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},{ validator: checkPassword, trigger: 'blur' }],
					againPassword: [{
						required: true,
						message: '请再次输入密码',
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: '请输入联系人手机号',
							trigger: 'blur'
						},
						{
							validator: checkMobile,
							trigger: 'change'
						}
					],
					companyName: [{
						required: true,
						message: '请输入公司名称',
						trigger: 'blur'
					}]
				},
				rulesApiForgetPwd: {
					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							validator: checkMail,
							trigger: 'change'
						},
					],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					},{ validator: checkPassword, trigger: 'blur' }],
					againPassword: [{
						required: true,
						message: '请再次输入密码',
						trigger: 'blur'
					}],
				},
				code: '',
				// 验证码规则
				visible: false,
				privacyPolicy: false,
				loginDialogVisible: false,
				registerDialogVisible: false,
				forgetPwdDialogVisible: false,
				codeShow: true,
				countCode: 0,
				timer: null,
			}
		},
		computed: {

		},
		beforeDestroy() {
			window.removeEventListener('wheel', this.preventBackgroundScroll);
		},
		methods: {
			adNavChange(item,index){
				this.adNavIndex = index
				this.adCheckedForm = item
			},
			showVisible(e){
				this.showLoginBox = e
			},
			changeLoginBox(){
				this.showLoginBox = !this.showLoginBox
			},
			planService() {
				this.$router.push({
					path: '/planService'
				})
			},
			inforMation() {
				this.$router.push({
					path: '/information'
				})
			},
			adHoverEnter(index){
				this.adIndex = index
			},
			navClick(e){
				// console.log(e)
				this.$refs.mySwiper.swiper.slideTo(e, 500);
			},
			// 隐私政策跳转
			privacy(type) {
				if (type == 1) {
					window.open('https://file.ssp.richmob.cn/privacy/user-agreement-richmob-web.html', '_blank')
				} else {
					window.open('https://file.ssp.richmob.cn/privacy/privacy-po-richmob-web.html', '_blank')
				}
			},
			openLoginBox() {
				this.registerDialogVisible = false
				this.forgetPwdDialogVisible = false
				this.loginDialogVisible = true
				this.clearTimer();
			},
			showRegisterBox() {
				this.loginDialogVisible = false
				this.forgetPwdDialogVisible = false
				this.registerDialogVisible = true
				this.clearTimer();
			},
			showForgetBox() {
				this.loginDialogVisible = false
				this.registerDialogVisible = false
				this.forgetPwdDialogVisible = true
				this.clearTimer();
			},
			closeBox() {
				this.loginDialogVisible = false
				this.registerDialogVisible = false
				this.forgetPwdDialogVisible = false
				this.clearTimer();
			},
			clearTimer() {
				this.passwordRegisterVisible = false
				clearInterval(this.timer);
				this.timer = null;
			},
			// 发送验证码
			sendCode(type) {
				let userMail = ''
				const regCN = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
				if (type == 1) {
					if (!this.registerFormData.email) {
						this.$message.warning('请输入邮箱!');
						return
					}
					if (!regCN.test(this.registerFormData.email)) {
						this.$message.warning('邮箱格式不正确!');
						return
					}
					userMail = this.registerFormData.email
				} else {
					if (!this.forgetPwdFormData.email) {
						this.$message.warning('请输入邮箱!');
						return
					}
					if (!regCN.test(this.forgetPwdFormData.email)) {
						this.$message.warning('邮箱格式不正确!');
						return
					}
					userMail = this.forgetPwdFormData.email
				}
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.getMailCode(userMail, type);
					clearInterval();
					this.countCode = TIME_COUNT;
					this.codeShow = false;
					this.timer = setInterval(() => {
						if (this.countCode > 0 && this.countCode <= TIME_COUNT) {
							this.countCode--;
						} else {
							this.codeShow = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000)
				}
			},
			async getMailCode(email, type) {
				let data = {
					email: email,
					type: type
				}
				let res = await this.$http.post(this.$api.sendCode, data);
				if (res.code == 1) {
					this.$message.success('验证码发送成功！请注意查收');
				}
			},
			// 登录
			confirmLogin(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (!this.privacyPolicy) {
							this.$message.warning('请阅读并同意服务协议和隐私条款');
							return
						}
						let data = this.loginFormData;
						let res = await this.$http.post(this.$api.mediaLoginSDK, data);
						if (res.code == 1) {
							this.$message.success('登录成功');
							this.closeBox();
							// localStorage.setItem("mediaSdkUser", JSON.stringify(res.data));
							// location.href = `http://119.45.48.13/#/?tk=${res.data.token}&lType=official`;
							// location.href = `http://175.27.236.174/#/?tk=${res.data.token}&lType=official`;
							location.href = `https://sdkdata.richmob.cn/#/?tk=${res.data.token}&lType=official`;
							// location.href = `http://192.168.1.59:8082/#/?tk=${res.data.token}&lType=official`;
						} else {
							this.$message.error(res.msg);
						}
					}
				});
			},
			// 注册
			confirmRegister(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (this.registerFormData.password !== this.registerFormData.againPassword) {
							this.$message.warning('两次输入的密码不一致,请重试!');
							return
						}
						let data = this.registerFormData;
						let res = await this.$http.post(this.$api.mediaRegisterSDK, data);
						if (res.code == 1) {
							this.$message.success('注册成功，请联系管理员等待审核通过');
							this.closeBox();
							// this.openLoginBox();
						} else {
							this.$message.error(res.msg);
						}
					}
				});
			},
			// 忘记密码
			confirmForgetPwd(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if (this.forgetPwdFormData.password !== this.forgetPwdFormData.againPassword) {
							this.$message.warning('两次输入的密码不一致,请重试!');
							return
						}
						let data = this.forgetPwdFormData;
						let res = await this.$http.post(this.$api.forgetPwd, data);
						if (res.code == 1) {
							this.$message.success('密码修改成功！');
							this.openLoginBox();
						} else {
							this.$message.error(res.msg);
						}
					}
				});
			},
		},
		created() {
			
		},
		mounted() {
			this.screenWidth = window.innerWidth
			// console.log(window.innerHeight)
			// console.log(window.innerWidth)
			this.adboxHeight = Math.floor(window.innerWidth * 0.46)
			this.adboxHeight_m = Math.floor(window.innerWidth * 1.05)
		},
	}
</script>

<style scoped>
	.main {}

	.swiperBox {
		width: 100%;
		height: 100vh;
	}

	.swiper-pagination {
		
	}
	/* .swiper-pagination ::v-deep .swiper-pagination-bullet{
		background: #DCDCDC;
		opacity: 1;
	}
	.swiper-pagination ::v-deep .swiper-pagination-bullet-active{
		background: #399FFA;
	} */

	.container {
		height: 100vh;
		overflow: hidden;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.heroSection {
		width: 100%;
		/* height: 878px; */
		/* background: url(../assets/index/adbg.jpg) no-repeat; */
		background-repeat: no-repeat;
		background-size: 100% 100%;
		position: relative;
		z-index: 99;
		font-family: PingFang SC;
	}

	.heroContent {
		max-width: 1200px;
		margin: 0 auto;
		padding-top: 7%;
		font-weight: 600;
		color: #333333;
	}

	.heroTagline {
		background: #BCD1FF;
		border-radius: 20px 20px 20px 20px;
		font-weight: 600;
		font-size: 16px;
		color: #333333;
		line-height: 40px;
		height: 40px;
		position: relative;
		z-index: 10;
		padding: 0 24px;
		align-items: center;
	}
	.heroTagline span {
		position: relative;
		z-index: 9;
	}
	.heroTaglineIcon{
		/* position: absolute;
		right: 0;
		bottom: -6px; */
		width: 24px;
		height: 24px;
		margin-left: 4px;
	}

	.heroHeading {
		margin-top: 24px;
		margin-bottom: 24px;
		font-weight: 600;
		font-size: 48px;
		color: #2173FF;
		line-height: 66px;
	}
	.heroHeading span{
		background: linear-gradient(to right, #3680FF, #21AEFF);
		/* background: linear-gradient(9.117deg, #3680FF 0%, #21AEFF 100%); */
		font-family: PingFang SC;
		background-clip: text;
		color: transparent;
	}

	.heroDescription {
		font-weight: 600;
		color: #333333;
		font-size: 20px;
		line-height: 23px;
	}
	.experienceBtn{
		width: 142px;
		height: 52px;
		line-height: 52px;
		background: linear-gradient( 270deg, #21AEFF 0%, #2173FF 100%);
		border-radius: 10px;
		font-weight: 600;
		font-size: 16px;
		color: #FFFFFF;
		text-align: center;
		cursor: pointer;
		margin-top: 34px;
	}
	
	.heroFeaturesWrap{
		width: 100%;
		position: absolute;
		bottom: -58px;
		left: 0%;
		transform: translate(0%, 0);
		background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 55%, #FFFFFF 100%);
	}
	.heroFeatures {
		max-width: 1200px;
		margin: 0 auto;
		background: rgba(255, 255, 255, 0.2);
		backdrop-filter: blur(8px);
		box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.1);
		border-radius: 8px 8px 8px 8px;
		border: 1px solid #FFFFFF;
		/* background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 55%, #FFFFFF 100%); */
	}

	.heroFeature {
		width: 384px;
		height: 114px;
		background: none;
		margin: 0 12px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding-left: 90px;
		box-sizing: border-box;
	}
	.heroFeatureHeading{
		align-items: center;
	}

	.heroFeatureIcon {
		width: 48px;
		height: 48px;
		padding-right: 15px;
	}

	.heroFeatureBody {
		/* margin-left: 14px; */
		/* margin-top: 10px; */
	}

	.heroFeatureTitle {
		font-weight: 600;
		font-size: 22px;
		color: #333333;
		line-height: 26px;
	}

	.heroFeatureText {
		margin-top: 12px;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
		line-height: 16px;
	}

	.productBox {
		padding-top: 6%;
		text-align: center;
		width: 100%;
		align-items: center;
		font-family: 'HarmonyOS_Sans_SC_Medium';
	}

	.productTitle, .productTitle2, .productTitle3, .productTitle2_m {
		font-family: 'HarmonyOS_Sans_SC_Medium';
		width: 610px;
		height: 97px;
		line-height: 125px;
		font-weight: bold;
		font-size: 64px;
		margin: 0 auto;
		color: #000000;
		background: url(../assets/index/productTxtBg.png) no-repeat;
		background-size: 610px 97px;
		/* padding-top: -11px; */
	}
	.productTitle2{
		width: 700px;
		height: 75px;
		line-height: 75px;
		/* background: url(../assets/index/productTxtBg2.png) no-repeat;
		background-size: 700px 96px; */
		background: none;
		position: relative;
		z-index: 10;
		text-align: left;
	}
	.productTitle2 div{
		position: relative;
		z-index: 10;
	}
	.productTitle2 span{
		background: linear-gradient(to right, #2173FF, #21AEFF);
		background-clip: text;
		color: transparent;
	}
	.productTitle2 img{
		position: absolute;
		left: 48px;
		top: -56px;
		width: 700px;
		height: 96px;
		z-index: 9;
	}
	.productTitle3{
		background: url(../assets/index/productTxtBg3.png) no-repeat;
		background-size: 888px 97px;
		width: 888px;
		height: 97px;
	}
	.productTitle3 span{
		background: linear-gradient(to right, #2173FF, #21AEFF);
		background-clip: text;
		color: transparent;
	}
	.productTitle span{
		/* color: #000000; */
		background: linear-gradient(to right, #2173FF, #21AEFF);
		background-clip: text;
		color: transparent;
	}

	.productTips {
		font-weight: blod;
		font-size: 16px;
		color: #666666;
		margin-top: 20px;
	}
	.adTabNavList{
		margin-top: 50px;
		font-family: 'HarmonyOS_Sans_SC_Medium';
	}
	.adTabNavBox{
		font-weight: 500;
		font-size: 16px;
		color: #333333;
		margin-right: 80px;
		border-bottom: 2px solid #FFFFFF;
		padding-bottom: 14px;
		cursor: pointer;
	}
	.adTabNavList :last-child{
		margin-right: 0;
	}
	.adMannerDescribe{
		font-weight: 500;
		font-size: 16px;
		color: rgba(51,51,51,0.8);
		line-height: 26px;
		height: 26px;
		text-align: left;
		margin-top: 30px;
	}
	.adNavActive{
		color: #2173FF;
		border-bottom: 2px solid #2173FF;
	}

	.productList {
		margin: 0 auto;
		margin-top: 70px;
		max-width: 1110px;
	}

	/* .proLeftBox,
	.proRightBox {
		width: 333px;
		height: 495px;
		background: url(../assets/index/proleft.png) no-repeat;
		background-size: 100% 100%;

	} */

	/* .proCenterBox {
		width: 384px;
		height: 495px;
		background: url(../assets/index/procenter.png) no-repeat;
		background-size: 100% 100%;
	} */
	.productBoxOne, .productBoxOne2, .productBoxOne3{
		width: 358px;
		height: 346px;
		background: url(../assets/index/productBoxOneBg.png) no-repeat;
		background-size: 100% 100%;
	}
	.productBoxOne2{
		background: url(../assets/index/productBoxBg2.png) no-repeat;
	}
	.productBoxOne3{
		background: url(../assets/index/productBoxBg3.png) no-repeat;
	}

	/* .proRightBox {
		background: url(../assets/index/proright.png) no-repeat;
		background-size: 100% 100%;
	} */

	.proTitle {
		padding-top: 54px;
		font-weight: bold;
		font-size: 24px;
		color: #333333;
	}
	.proTitle span{
		color: #2173FF;
	}
	.proSplitLine{
		background: url(../assets/index/splitLine.png) no-repeat;
		background-size: 38px 4px;
		width: 38px;
		height: 4px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.proCont {
		padding: 0 38px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 14px;
		color: #38517C;
		line-height: 26px;
		margin-top: 40px;
		text-align: left;
	}
	.proBottomBox{
		width: 1200px;
		height: 160px;
		background: url(../assets/index/proBottomBg.png) no-repeat;
		background-size: 100% 100%;
		font-weight: bold;
		font-size: 24px;
		color: #FFFFFF;
		font-family: 'HarmonyOS_Sans_SC_Medium';
		text-align: center;
		margin: 0 auto;
		padding-top: 90px;
		box-sizing: border-box;
		margin-top: -38px;
	}
	
	/* .adHoverList{
		margin: 0 auto;
		margin-top: 70px;
		max-width: 1200px;
		background: url(../assets/index/adbg2.png) no-repeat;
		background-size: 100% 600px;
		padding-top: 38px;
		position: relative;
	} */
	.adCenterImg{
		width: 384px;
		height: 384px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-46%, -50%);
	}
	.adHoverRow, .adHoverRow2{
		padding-top: 10px;
		margin-bottom: 66px;
	}
	.adHoverRow2{
		margin-bottom: 60px;
	}
	.adLeftBox, .adRightBox{
		text-align: left;
		width: 258px;
		flex-wrap: wrap;
		cursor: pointer;
	}
	.adRightBox{
		text-align: right !important;
	}
	.adHoverTitle{
		font-weight: 600;
		font-size: 22px;
		color: #333333;
		line-height: 26px;
	}
	.adRightBox:hover .adHoverTitle{
		color: #1B68DD;
	}
	.adLeftBox:hover .adHoverTitle{
		color: #1B68DD;
	}
	.adHoverCont{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-top: 16px;
		text-align: left;
		line-height: 20px;
	}
	.adRightShow{
		width: 400px;
		height: 400px;
		background: url(../assets/index/adRightBg.png) no-repeat;
		background-size: 100% 100%;
		margin-left: 100px;
		align-items: center;
	}
	.adRightShow img{
		width: 260px;
		height: 550px;
	}
	
	
	.cooperateRow{
		margin: 0 auto;
		margin-top: 80px;
		max-width: 1200px;
		align-items: center;
	}
	.cooperateBox{
		text-align: left;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-top: 50px;
	}
	.contactusTit{
		font-weight: 500;
		font-size: 36px;
		color: #0D3A7D;
	}
	.contactusTxt{
		margin-top: 12px;
		font-weight: 500;
		font-size: 18px;
		color: #0D3A7D;
	}
	.contactQQ{
		width: 180px;
		height: 44px;
		background: #2173FF;
		border-radius: 4px;
		align-items: center;
		margin-top: 20px;
	}
	.qqImg{
		width: 24px;
		height:24px;
	}
	.qqTxt{
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		margin-left: 6px;
	}
	.contactLabels{
		margin-top: 20px;
	}
	.contactLabelTxt{
		font-weight: 500;
		font-size: 14px;
		color: #2173FF;
		margin-right: 6px;
	}
	.cooperateImg{
		width: 1200px;
		height: 312px;
	}
	.cooperateBottomRow{
		margin: 0 auto;
		max-width: 1200px;
		margin-top: 75px;
		align-items: center;
	}
	.bottomLogo{
		width: 152px;
		height: 56px;
	}
	.icpTxt{
		font-weight: 500;
		font-size: 12px;
		color: #000000;
		/* margin-left: 500px; */
	}
	.icpTxt span{
		color: #336DCF;
	}
	
	
	.el-form-dialog /deep/.el-form-item {
		width: 100%;
		margin-bottom: 20px;
	}
	
	.el-form-dialog /deep/.el-form-item__content {
		width: 100%;
	}
	
	/deep/.el-dialog__header {
		padding-top: 30px;
	}
	
	/deep/.el-dialog__headerbtn {
		top: 30px;
	}
	
	/deep/.el-dialog__body {
		padding: 30px 32px;
		padding-top: 20px;
	}
	
	.el-form-dialog /deep/.el-input__inner {
		line-height: 48px;
		height: 48px;
		background-color: #F7F7F7;
		border: none;
	}
	/deep/ .el-input-group__append {
		border: none;
		background: #F7F7F7;
	}
	.eyesImg{
		width: 24px;
		height: 24px;
		cursor: pointer;
	}
	
	.privacyPolicy {
		color: #999999;
		font-size: 12px;
	}
	
	.privacyPolicy span {
		color: #007FFF;
		cursor: pointer;
	}
	
	.bottomTips {
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		margin-top: 16px;
	}
	
	.bottomTips div {
		cursor: pointer;
	}
	.loginBtns {
		width: 100%;
		height: 46px;
		/* background: linear-gradient(0deg,#0060ff,#0096ff); */
		background: #007FFF;
		border-radius: 2px;
		font-size: 14px;
		line-height: 46px;
		text-align: center;
		color: #FFFFFF;
		cursor: pointer;
		padding: 0;
		/* margin-top: 40px; */
	}
	
	
	@media screen and (min-width:1000px) and (max-width:1200px) {
		.heroContent{
			max-width: 1000px;
			padding-top: 5%;
		}
		.heroHeading{
			font-size: 34px;
			line-height: 44px;
			margin-top: 15px;
		}
		.heroFeatures{
			width: 1000px;
		}
		.experienceBtn{
			width: 120px;
			height: 40px;
			line-height: 40px;
			font-size: 14px;
		}
		.adTabNavBox{
			margin-right: 40px;
		}
		.cooperateImg{
			width: 1000px;
			height: 260px;
		}
		.productTitle2{
			height: 54px;
			line-height: 54px;
			width: 500px;
			font-size: 48px;
		}
		.productTitle2 img{
			width: 500px;
			height: 69px;
			top: -12px;
		}
		.productList{
			max-width: 950px;
		}
		.proBottomBox{
			width: 1000px;
		}
		.productBoxOne, .productBoxOne2, .productBoxOne3{
			width: 300px;
			height: 290px;
			margin-top: 15px;
		}
		.proTitle{
			font-size: 20px;
		}
		.proCont{
			font-size: 13px;
			margin-top: 20px;
		}
		.productTitle, .productTitle2, .productTitle3 {
			width: 480px;
			line-height: 96px;
			height: 80px;
			font-size: 48px;
			background-size: 100% auto;
		}
	}
	@media screen and (min-width:1200px) and (max-width:1900px) {
	    /* .adHoverList{
	    	margin: 0 auto;
	    	margin-top: 70px;
	    	width: 1100px;
	    	background: url(../assets/index/adbg2.png) no-repeat;
	    	background-size: 1100px 550px;
	    	padding-top: 20px;
	    	position: relative;
	    } */
			.adCenterImg{
				width: 310px;
				height: 310px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-48%, -52%);
			}
			.adLeftBox, .adRightBox{
				text-align: left;
				width: 228px;
				flex-wrap: wrap;
				cursor: pointer;
			}
			.adHoverRow, .adHoverRow2{
				padding-top: 20px;
				margin-bottom: 20px;
			}
			.adHoverRow2{
				margin-bottom: 15px;
			}
			.cooperateRow{
				margin: 0 auto;
				margin-top: 30px;
				max-width: 1200px;
				align-items: center;
			}
			.cooperateBottomRow{
				margin: 0 auto;
				max-width: 1200px;
				margin-top: 70px;
				align-items: center;
			}
	}
	@media screen and (max-width: 750px) {
		.heroTagline{
			width: 264px;
			height: 26px;
			line-height: 26px;
			margin: 0 auto;
			margin-top: 16px;
			font-size: 11px;
			padding: 0;
			background: #E4EDFF;
		}
		.heroTagline span {
			position: relative;
			z-index: 9;
		}
		.heroTaglineIcon{
			/* position: absolute;
			right: 0;
			bottom: -6px; */
			width: 14px;
			height: 14px;
			margin-left: 4px;
		}
		.heroSection{
			padding-top: 20px;
			box-sizing: border-box;
			/* margin-top: 20px; */
		}
		.heroHeading {
			font-size: 28px;
			text-align: center;
			margin-bottom: 6px;
			font-weight: 600;
			line-height: 36px;
			margin-top: 0;
		}
		.heroHeading span{
			background: linear-gradient(to right, #3680FF, #21AEFF);
			/* background: linear-gradient(9.117deg, #3680FF 0%, #21AEFF 100%); */
			font-family: PingFang SC;
			background-clip: text;
			color: transparent;
		}
		
		.heroDescription {
			font-weight: 500;
			color: rgba(51,51,51,0.6);
			font-size: 12px;
			text-align: center;
			margin: 15px 0;
		}
		.experienceBtn{
			margin: o auto;
			width: 120px;
			height: 38px;
			line-height: 38px;
			background: linear-gradient( 270deg, #21AEFF 0%, #2173FF 100%);
			border-radius: 8px;
			font-size: 11px;
			color: #FFFFFF;
			margin-top: 12px;
		}
		.heroFeatures {
			width: 94%;
			margin: 0 auto;
			margin-top: -15px;
			background: rgba(255, 255, 255, 0.2);
			backdrop-filter: blur(8px);
			box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.06);
			/* background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 55%, #FFFFFF 100%); */
		}
		.heroFeature {
			height: 90px;
			width: auto;
			margin: 0 16px;
			padding-left: 0;
			border-bottom: 1px dashed #CBD2DC;
		}
		.heroFeatureIcon {
			width: 36px;
			height: 36px;
			padding-right: 14px;
		}
		.heroFeatureTitle {
			font-size: 16px;
			line-height: 22px;
		}
		.heroFeatureText {
			margin-top: 8px;
			font-size: 12px;
			color: #565c66;
		}
		.productList{
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 50px;
		}
		.productBox{
			padding-top: 30px;
		}
		.productTitle, .productTitle2, .productTitle3, .productTitle2_m {
			width: 94%;
			line-height: 90px;
			font-size: 34px;
			background-size: 100% auto;
		}
		.productTitle2_m{
			background: url(../assets/index/productTxtBg2.png) no-repeat;
			height: 80px;
			line-height: 70px;
			background-size: 100% auto;
		}
		.productTitle2_m span{
			background: linear-gradient(to right, #2173FF, #21AEFF);
			background-clip: text;
			color: transparent;
		}
		.productTitle3{
			background-size: 100% auto;
			height: 80px;
			line-height: 90px;
		}
		.productTips {
			font-size: 14px;
			color: #666666;
			margin-top: 5px;
		}
		.productBoxOne, .productBoxOne2, .productBoxOne3{
			width: 347px;
			height: 335px;
			margin-top: 15px;
		}
		.proTitle {
			padding-top: 50px;
		}
		.proSplitLine{
			margin-top: 18px;
		}
		.proBottomBox{
			width: 90%;
			height: 50px;
			background-size: 100% 100%;
			padding-top: 22px;
			font-size: 14px;
			margin-top: -10px;
		}
		.adTabNavList{
			width: 94%;
			margin:  auto;
			margin-top: 28px;
		}
		.adTabNavBox{
			font-size: 14px;
			margin-right: 0px;
			padding-bottom: 12px;
		}
		.adMannerDescribe{
			padding-left: 16px;
			font-size: 12px;
			margin-top: 14px;
		}
		.adRightShow{
			width: 345px;
			height: 345px;
			margin: 0 auto;
			margin-top: 90px;
			margin-bottom: 90px;
		}
		.adRightShow img{
			width: 223px;
			height: 473px;
		}
		.cooperateImg{
			width: 94%;
			height: auto;
		}
		.cooperateRow{
			margin-top: 28px;
		}
		.cooperateBox{
			margin-top: 40px;
		}
		.contactusTit{
			font-size: 20px;
		}
		.contactQQ{
			width: 135px;
			height: 33px;
			border-radius: 3px;
			margin-top: 16px;
		}
		.qqImg{
			width: 18px;
			height:18px;
		}
		.qqTxt{
			font-size: 11px;
			margin-left: 5px;
		}
		.contactLabelTxt{
			font-size: 12px;
			margin-right: 10px;
		}
		
		.cooperateBottomRow{
			margin-top: 40px;
		}
		.icpTxt{
			padding-bottom: 15px;
			font-size: 10px;
		}
		.icpTxt a{
			margin-left: 16px;
		}
		.proBoxBg{
			/* background: linear-gradient( 181deg, #FFFFFF 0%, rgba(255,255,255,0) 89%); */
			background: url(../assets/index/cooperateBg_m.png) no-repeat;
			background-size: 100% auto;
		}
	}

	img {
		width: 100%;
		height: 100%;
	}
</style>